var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrarSesionMiniIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.557,
    height: 20.495,
    viewBox: "0 0 20.557 20.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_370",
    "data-name": "Grupo 370",
    transform: "translate(-1554 -269.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M85.5,753.679H78.559V739.788H85.5a1.651,1.651,0,1,0,0-3.3H78.47a3.217,3.217,0,0,0-3.213,3.214v14.067a3.217,3.217,0,0,0,3.213,3.214H85.5a1.651,1.651,0,1,0,0-3.3Z",
    transform: "translate(1478.743 -466.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M101.956,749.7l-4.751-4.689a1.651,1.651,0,1,0-2.319,2.35l1.887,1.863H89.793a1.651,1.651,0,0,0,0,3.3h6.981l-1.887,1.862a1.651,1.651,0,1,0,2.318,2.351l4.753-4.69a1.665,1.665,0,0,0,.491-1.175A1.641,1.641,0,0,0,101.956,749.7Z",
    transform: "translate(1472.11 -471.107)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSesionMiniIcon);
export default __webpack_public_path__ + "static/media/cerrar-sesion-mini-icon.db95959002aa870eec392f7e33f8ac84.svg";
export { ForwardRef as ReactComponent };